import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Store/StoreFeatures/storeFeatures.default"
    ).then((module) => ({
        default: module.StoreFeaturesDefault
    }))
);
